// extracted by mini-css-extract-plugin
export default {"container":"BorderedIcon-module__container--yFILb","topic":"BorderedIcon-module__topic--wvVNJ"};